module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq760-530b1d20e097638edae58f26328cfdca.jpg";